import { useRef } from "react";
import { ImagePlus, Camera, ChevronLeft, ChevronRight, Trash2, FileCheck2 } from "lucide-react";
import { useLang } from "../lib/i18n";

export default function PendingPhotos({ items, setItems }) {
  const { t } = useLang();
  const lib = useRef();
  const cam = useRef();
  const add = (files) => {
    const next = [...files].filter((f) => f.type.startsWith("image/")).map((file) => ({
      key: `${file.name}-${file.size}-${Math.random()}`, file, url: URL.createObjectURL(file), caption: "", area: "", include: true,
    }));
    setItems([...items, ...next]);
    lib.current.value = "";
    cam.current.value = "";
  };
  const upd = (i, patch) => setItems(items.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  const move = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= items.length) return;
    const n = [...items];
    [n[i], n[j]] = [n[j], n[i]];
    setItems(n);
  };
  const del = (i) => { URL.revokeObjectURL(items[i].url); setItems(items.filter((_, j) => j !== i)); };
  return (
    <section className="card p-4" data-testid="estimate-pending-photos">
      <h3 className="font-bold mb-1">{t("PROJECT PHOTOS", "FOTOS DEL PROYECTO")} <span className="mono text-xs text-slate-400">({items.length})</span></h3>
      <p className="text-xs text-slate-500 mb-3">{t("Photos are saved with the estimate when you tap Save Draft, Generate PDF or Send.", "Las fotos se guardan con el presupuesto al tocar Guardar, Generar PDF o Enviar.")}</p>
      <input ref={lib} type="file" accept="image/*" multiple hidden onChange={(e) => add(e.target.files)} data-testid="pending-photo-input" />
      <input ref={cam} type="file" accept="image/*" capture="environment" hidden onChange={(e) => add(e.target.files)} data-testid="pending-photo-camera-input" />
      <div className="grid grid-cols-2 gap-2 mb-3">
        <button type="button" className="btn-primary h-14 text-base" onClick={() => lib.current.click()} data-testid="pending-photo-add-btn"><ImagePlus className="w-5 h-5" /> {t("+ Add Photos", "+ Agregar fotos")}</button>
        <button type="button" className="btn-outline h-14" onClick={() => cam.current.click()} data-testid="pending-photo-take-btn"><Camera className="w-5 h-5" /> {t("Take Photo", "Tomar foto")}</button>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((p, i) => (
          <div key={p.key} className="rounded-xl border border-slate-200 overflow-hidden" data-testid={`pending-photo-${i}`}>
            <img src={p.url} alt="" className="w-full aspect-[4/3] object-cover bg-slate-100" />
            <div className="p-2 grid gap-2">
              <input className="inp h-11 text-sm" placeholder={t("Caption / description", "Descripción")} value={p.caption} onChange={(e) => upd(i, { caption: e.target.value })} data-testid={`pending-photo-caption-${i}`} />
              <input className="inp h-11 text-sm" placeholder={t("Area / location", "Área / ubicación")} value={p.area} onChange={(e) => upd(i, { area: e.target.value })} data-testid={`pending-photo-area-${i}`} />
              <button type="button" onClick={() => upd(i, { include: !p.include })} className={`min-h-[44px] rounded-lg text-sm font-bold flex items-center justify-center gap-1 ${p.include ? "bg-emerald-600 text-white" : "bg-slate-100 text-slate-600"}`} data-testid={`pending-photo-include-${i}`}>
                <FileCheck2 className="w-4 h-4" /> {p.include ? t("Include in PDF: Yes", "Incluir en PDF: Sí") : t("Include in PDF: No", "Incluir en PDF: No")}
              </button>
              <div className="grid grid-cols-3 gap-2">
                <button type="button" className="btn-outline btn-sm" onClick={() => move(i, -1)} aria-label="Move left" data-testid={`pending-photo-left-${i}`}><ChevronLeft className="w-5 h-5" /></button>
                <button type="button" className="btn-outline btn-sm" onClick={() => move(i, 1)} aria-label="Move right" data-testid={`pending-photo-right-${i}`}><ChevronRight className="w-5 h-5" /></button>
                <button type="button" className="btn-danger btn-sm" onClick={() => del(i)} aria-label="Delete" data-testid={`pending-photo-delete-${i}`}><Trash2 className="w-5 h-5" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
